/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IObrienHomeHero23Data } from './obrien-home-hero23.data';
import { IObrienHomeHero23Props } from './obrien-home-hero23.props.autogenerated';

import LinksComponent from './components/links';

export interface IObrienHomeHero23ViewProps extends IObrienHomeHero23Props<IObrienHomeHero23Data> {
    obHeroTitle: React.ReactNode;
    obHeroImage: React.ReactNode;
    obHeroImageOverlay: React.ReactNode;
    obHeroId: string;
    obHeroContent: string;
    obHeroButtonLink: string;
    obHeroButtonText: string;
    imageContainer: INodeProps;
    links?: React.ReactNode;

}

/**
 *
 * ObrienHomeHero component
 * @extends {React.PureComponent<IObrienHomeHero23Props<IObrienHomeHero23Data>>}
 */
class ObrienHomeHero23 extends React.PureComponent<IObrienHomeHero23Props<IObrienHomeHero23Data>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const { obHeroImage, obHeroImageOverlay, obHeroTitle, links } = this.props.config;

        //const HeroTitle = config.obHeroTitle ? config.obHeroTitle : 'No Header Name Provided';

        const HeroTitle = obHeroTitle && (
            <Msdyn365.Text
              tag={obHeroTitle.tag || 'h2'}
              text={obHeroTitle.text}
              className='ob-hero-title'
              editProps={{onEdit: this.handleTextChange1, requestContext:this.props.context.request}}
            />
        );

        const imageProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obHeroImage && obHeroImage.imageSettings,
        };

        const heroImage = obHeroImage && (
            <Msdyn365.Image {...obHeroImage} {...imageProps} editProps ={{key:this.props.config.obHeroImage || {}, requestContext: this.props.context.request}}/>
        );

        const imageOverlayProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obHeroImageOverlay && obHeroImageOverlay.imageSettings,
        };

        const heroImageOverlay = obHeroImageOverlay && (
            <Msdyn365.Image {...obHeroImageOverlay} {...imageOverlayProps} editProps ={{key:this.props.config.obHeroImageOverlay || {}, requestContext: this.props.context.request}}/>
        );

        const contentBlockLinks = links && links.length > 0 && <LinksComponent {...{ links }} />;

        //const HeroImage = config.obHeroImage ? config.obHeroImage.src : '';
        const HeroId = config.obHeroId ? config.obHeroId : 'No Id';
        const HeroContent = config.obHeroContent ? config.obHeroContent : '';
        const HeroButtonLink = config.obHeroButtonLink ? config.obHeroButtonLink : null;
        const HeroButtonText = config.obHeroButtonText ? config.obHeroButtonText : null;
        const ObrienHomeHeroProps = {
            ...this.props,
            obHeroTitle: HeroTitle,
            obHeroImage: heroImage,
            obHeroImageOverlay: heroImageOverlay,
            obHeroId: HeroId,
            obHeroContent: HeroContent,
            obHeroButtonLink: HeroButtonLink,
            obHeroButtonText: HeroButtonText,
            imageContainer: {},
            links: contentBlockLinks
        };

        return this.props.renderView(ObrienHomeHeroProps);
    }
    public handleTextChange1 = (event: Msdyn365.ContentEditableEvent) => this.props.config.obHeroTitle!.text = event.target.value;
}

export default ObrienHomeHero23;
